module.exports = __webpack_public_path__ + "static/media/Screenshot_app_3.783a38c0.png";